import { render, staticRenderFns } from "./RegisterMobileVerification.vue?vue&type=template&id=24e57932&scoped=true"
import script from "./RegisterMobileVerification.vue?vue&type=script&lang=js"
export * from "./RegisterMobileVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e57932",
  null
  
)

export default component.exports